import { Component, Renderer2, ViewChild } from '@angular/core';
import { LayoutService } from '../../service/layout.service';
import { filter, Subscription } from 'rxjs';
import { AppSidebarComponent } from '../app-sidebar/app-sidebar.component';
import { AppTopbarComponent } from '../app-topbar/app-topbar.component';
import { NavigationEnd, Router } from '@angular/router';
import { SystemContextService } from '@app/core/services/system-context.service';

@Component({
    selector: 'app-layout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.scss'],
    standalone: false
})
export class AppLayoutComponent {
    // overlayMenuOpenSubscription: Subscription;

    menuOutsideClickListener: any;

    @ViewChild(AppSidebarComponent) AppSidebarComponent!: AppSidebarComponent;

    @ViewChild(AppTopbarComponent) AppTopbarComponent!: AppTopbarComponent;

    // ► link para la casita (usa el system actual)
    homeLink: any[] = ['/'];

    constructor(
        public layoutService: LayoutService,
        public renderer: Renderer2,
        public router: Router,
        private systemContext: SystemContextService
    ) {
        // this.overlayMenuOpenSubscription = this.layoutService.overlayOpen$.subscribe(() => {
        //     if (!this.menuOutsideClickListener) {
        //         this.menuOutsideClickListener = this.renderer.listen('document', 'click', (event) => {
        //             if (this.isOutsideClicked(event)) {
        //                 this.hideMenu();
        //             }
        //         });
        //     }

        //     if (this.layoutService.layoutState().staticMenuMobileActive) {
        //         this.blockBodyScroll();
        //     }
        // });

        // this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        //     this.hideMenu();
        // });

        // set inicial del home según el system
        const sys = this.systemContext.getSystem?.() || '';
        this.homeLink = sys ? ['/', sys] : ['/'];
    }

    // isOutsideClicked(event: MouseEvent) {
    //     const sidebarEl = document.querySelector('.layout-sidebar');
    //     const topbarEl = document.querySelector('.layout-menu-button');
    //     const eventTarget = event.target as Node;

    //     return !(sidebarEl?.isSameNode(eventTarget) || sidebarEl?.contains(eventTarget) || topbarEl?.isSameNode(eventTarget) || topbarEl?.contains(eventTarget));
    // }

    // hideMenu() {
    //     this.layoutService.layoutState.update((prev) => ({ ...prev, overlayMenuActive: false, staticMenuMobileActive: false, menuHoverActive: false }));
    //     if (this.menuOutsideClickListener) {
    //         this.menuOutsideClickListener();
    //         this.menuOutsideClickListener = null;
    //     }
    //     this.unblockBodyScroll();
    // }

    blockBodyScroll(): void {
        // if (document.body.classList) {
        //     document.body.classList.add('blocked-scroll');
        // } else {
        //     document.body.className += ' blocked-scroll';
        // }
    }

    unblockBodyScroll(): void {
        // if (document.body.classList) {
        //     document.body.classList.remove('blocked-scroll');
        // } else {
        //     document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        // }
    }

    get containerClass() {
        return {
            'layout-overlay': this.layoutService.layoutConfig().menuMode === 'overlay',
            'layout-static': this.layoutService.layoutConfig().menuMode === 'static',
            'layout-static-inactive': this.layoutService.layoutState().staticMenuDesktopInactive && this.layoutService.layoutConfig().menuMode === 'static',
            'layout-overlay-active': this.layoutService.layoutState().overlayMenuActive,
            'layout-mobile-active': this.layoutService.layoutState().staticMenuMobileActive
        };
    }

    ngOnDestroy() {
        // if (this.overlayMenuOpenSubscription) {
        //     this.overlayMenuOpenSubscription.unsubscribe();
        // }
        // if (this.menuOutsideClickListener) {
        //     this.menuOutsideClickListener();
        // }
    }
}
